/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import ApiCalls from '../../custom-classes/api-calls';
import Select from 'react-select';
/**
 * Handles the selection of products
 */
class SelectorStudentProduct extends React.Component{

    constructor(props)
    {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        let languages = [
            { name: "English", code: "en" },
            { name: "Español", code: "es" }
        ];

        this.state = {
            options: [], // The options to fill the selection
            studentId:  this.props.data.studentId !=  null
                ? this.props.data.studentId.value: null,
            languages: languages
        };
    }

    componentWillReceiveProps(nextProps){
        this.setState({studentId: nextProps.data.studentId.value},
            ()=>{
                this.mountData();
            });
    }

    mountData(){
        // This is promise
        let apiCall = ApiCalls.getProfileProducts(this.state.studentId);
        let arrOptions = [];

        // After the api call, fill the data
        apiCall.then((data) => {
            console.log(data);
            for (let i = 0; i < data.Items.length; i++)
            {
                arrOptions.push(
                    {value: data.Items[i].ItemId, label: data.Items[i].Name }
                );
            }
        }).then(() =>{
            this.setState({
                options: arrOptions
            });
        });
    }

    /**
     * Call the webservices for the subscription and fill those selects
     * Component will mount is required for selects with API calls.
     */
    componentWillMount()
    {
       this.mountData();
    }

    /**
     * Handles the change event to get the selected value. Do not change this function
     */
    handleChange = (selectedOption) => {
        this.setState({value: selectedOption }, ()=>{
            this.props.updateParent(this.state.value);
            return this.state.value;
        });
    };

    /**
     * Renders the item list
     * @returns {XML} Returns an XML of the selection
     */
    render(){
        return (
            <Select onChange={this.handleChange} value={this.props.value} options={this.state.options}/>
        )
    }
}

export default SelectorStudentProduct;


// WEBPACK FOOTER //
// ./src/components/selectors/selector-student-products.js